import { Image } from "@tiptap/extension-image";
import { mergeAttributes } from "@tiptap/core";

export const CustomImage = Image.extend({
  renderHTML({ node, HTMLAttributes }) {
    const { textAlign } = node.attrs;

    const imgAttrs = mergeAttributes(HTMLAttributes, {
      alt: "Header Image",
      style: "max-width: 100%; height: auto;",
    });

    const imgTag = ["img", imgAttrs];

    if (textAlign === "center") {
      return [
        "div",
        {
          style:
            "text-align: center; display: flex; align-items: center; justify-content: center; border-bottom: 2px solid #ccc; padding-bottom: 10px; margin-bottom: 20px;",
        },
        imgTag,
      ];
    }

    return [
      "div",
      {
        style: `text-align: ${textAlign || "left"};`,
      },
      imgTag,
    ];
  },
});

export default CustomImage;
